import { Routes } from '@angular/router';
import { NotFoundComponent } from '../not-found/not-found.component';
import { CustomerEditComponent } from './sub-pages/customers/components/customer-edit/customer-edit.component';
import { CustomerSearchComponent } from './sub-pages/customers/components/customer-search/customer-search.component';
import { CustomersViewComponent } from './sub-pages/customers/customers-view.component';
import { LogsComponent } from './sub-pages/logs/logs.component';
import { UserEditComponent } from './sub-pages/users/sub-pages/user-edit/user-edit.component';
import { UserSearchComponent } from './sub-pages/users/sub-pages/user-search/user-search.component';
import { UsersViewComponent } from './sub-pages/users/users-view.component';

export const AdminRoutes: Routes = [
  {
    path: '', redirectTo: 'users/search', pathMatch: 'full',
  },
  {
    path: 'users', component: UsersViewComponent, children: [
      {path: '', redirectTo: 'search', pathMatch: 'full'},
      {
        path: 'search', component: UserSearchComponent, pathMatch: 'full'
      },
      {
        path: 'edit/:id', component: UserEditComponent, pathMatch: 'full'
      },
    ]
  },
  {
    path: 'customers', component: CustomersViewComponent, children: [
      {path: '', redirectTo: 'search', pathMatch: 'full'},
      {
        path: 'search', component: CustomerSearchComponent, pathMatch: 'full'
      },
      {
        path: 'edit/:id', component: CustomerEditComponent, pathMatch: 'full'
      },
    ]
  },
  {
    path: 'logs', component: LogsComponent, pathMatch: 'full',
  },
  {
    path: '404', component: NotFoundComponent, pathMatch: 'full'
  },
  {
    path: '**', redirectTo: '/404', pathMatch: 'full'
  }
];


